<script lang="ts" setup>
    import { formatDateTime } from '@cwd/Shared/utils/formatDateTime';
    import { formatNumber } from '@cwd/Shared/utils/formatNumber';
    import { getSubscriptionStatusClass } from '@views/BackOffice/Subscription/Subscription.access';
    import { onMounted } from 'vue';
    import { ServiceSubscriptionListItem } from './SubscriptionList.access';

    const props = defineProps<{
        subscription: ServiceSubscriptionListItem;
        index: number;
    }>();

    onMounted(async () => {});
</script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)" v-if="subscription">
        <h4 class="d-flex flex-wrap gap-xs align-items-baseline">
            <i class="fa fa-square" aria-hidden="true" :class="getSubscriptionStatusClass(subscription)"></i>
            <router-link :to="{ name: 'SubscriptionEdit', params: { serviceSubscriptionId: subscription.ServiceSubscriptionId } }">
                {{ subscription.ClientCompanyName }}
            </router-link>
        </h4>

        <p>
            {{ subscription.Tier }} {{ formatNumber(subscription.TierContactLimit) }}
            <span v-if="subscription.monthlyPriceWithAddons != null">
                | {{ formatNumber(subscription.monthlyPriceWithAddons) }} {{ subscription.CurrencyCode }}
            </span>
        </p>

        <p class="meta">
            <i class="fa fa-leaf" aria-hidden="true"></i>
            {{ $Resources.CreatedLabel }}
            <time :datetime="subscription.Created">{{ formatDateTime(subscription.Created) }}</time>

            <template v-if="subscription.ClientCompanyEmail != null">
                <i class="fa fa-user" aria-hidden="true"></i>
                {{ subscription.ClientCompanyEmail }}
            </template>
        </p>
    </div>

    <!-- <div style="min-width: min(240px, 100%)">
        <div class="d-flex col-gap-lg flex-wrap ug-values m-0-all">
            <div class="ug-value">
                <span class="ug-value-label">Contacts</span>
                <span class="ug-value-indicator m-xs-r" :class="subscription.ContactCount > subscription.TierContactLimit ? 'fail' : 'success'"></span>
                {{ formatNumber(subscription.ContactCount) }}
            </div>
        </div>
    </div> -->
</template>

<style></style>
